/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { sortBy } from 'lodash';

export const sortAndShiftHomePage = (menuItems, sortMode) => {
  const source = menuItems || [];
  const sortedMenuItems = sortMode === 'default' ? [...source] : sortBy(source, item => item.label);

  const homePageIndex = sortedMenuItems.findIndex(item => item?.isHomePage);

  if (homePageIndex > 0) {
    const [homePageItem] = sortedMenuItems.splice(homePageIndex, 1);

    sortedMenuItems.unshift(homePageItem);
  }

  return sortedMenuItems;
};

export const mapChildrenAndUpdatePaths = (configItem, translateMessage) => {
  const mappedChildren = configItem.children.map(child => ({
    ...child,
    path: `${configItem.path}${child.path}`,
    label: translateMessage(child.labelStringId),
  }));

  return sortAndShiftHomePage(mappedChildren, configItem.sortMode);
};
